<template>
  <div :class="$style.text">
    <HeadingExtraSmall weight="semibold">
      The installer will then:
    </HeadingExtraSmall>
    <ol>
      <li>
        Check for compatibility.
      </li>
      <li>
        Check to ensure the system clock is accurate.
      </li>
      <li>
        Generate a private key and certificate signing request, used for secure
        communications with the JumpCloud.
      </li>
      <li>
        Install dependencies.
      </li>
      <li>
        Download the JC agent.
      </li>
      <li>
        Create a "jcagent" service, which will be configured to run at boot.
      </li>
      <li>
        Start the agent.
      </li>
    </ol>
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
} from '@jumpcloud/ui-components';

export default {
  name: 'InstallerNotes',

  components: {
    HeadingExtraSmall,
  },
};
</script>

<style scoped module>
.text {
  color: var(--jc-color-neutral-text-descriptive);
}
</style>
